"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.PopVariant = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var PopVariant = /*#__PURE__*/function () {
  function PopVariant(modalVarRef, modalDClassRef, dClassesList) {
    (0, _classCallCheck2["default"])(this, PopVariant);
    this.dClassesList = [];
    if (!modalVarRef || !modalVarRef.open) throw 'Wrong ModalVariant instance';
    if (!modalDClassRef || !modalDClassRef.open) throw 'Wrong ModalDClass instance';
    this.modalVarRef = modalVarRef;
    this.modalDClassRef = modalDClassRef;
    this.dClassesList = dClassesList;
  }
  (0, _createClass2["default"])(PopVariant, [{
    key: "selectVariant",
    value: function () {
      var _selectVariant = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(variant, rule, catalog) {
        var _this = this;
        return _regenerator["default"].wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                var _context;
                if (variant.classe && (0, _indexOf["default"])(_context = _this.dClassesList).call(_context, variant.classe.ex("||", 1).toLowerCase()) > -1) {
                  _this.modalDClassRef.open(variant, rule, catalog).then(function (data) {
                    if (!data) reject(new Error('Data not valid from variant popup'));
                    if (!data.cod) reject(new Error('Missing variant code from variant popup'));
                    if (!data.cod) reject(new Error('Missing variant value from variant popup'));
                    resolve(data);
                  })["catch"](reject);
                } else {
                  _this.modalVarRef.open(variant, rule, catalog).then(function (data) {
                    if (!data) reject(new Error('Data not valid from variant popup'));
                    if (!data.cod) reject(new Error('Missing variant code from variant popup'));
                    if (!data.cod) reject(new Error('Missing variant value from variant popup'));
                    resolve(data);
                  })["catch"](reject);
                }
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      }));
      function selectVariant(_x, _x2, _x3) {
        return _selectVariant.apply(this, arguments);
      }
      return selectVariant;
    }()
  }]);
  return PopVariant;
}();
exports.PopVariant = PopVariant;
//# sourceMappingURL=PopVariant.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/PopVariant.js
// module id = 1246
// module chunks = 142